import React, { Fragment, useContext, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
import classes from "../DefaultPage/DefaultPage.module.css";
import { IoClose } from "react-icons/io5";
import GlobalContext from "../../providers/GlobalProvider";

export default function Form() {
  const { defaultMapper } = useContext(GlobalContext);
  const IASLiveMapper = "IAS Libra Live";

  const [close, setClose] = useState(false);

  function handleBurgerClick() {
    setClose((prev) => !prev);
  }

  return (
    <Fragment>
      {!close ? (
        <>
          <div className={classes.menu}>
            <Link to="#">
              <GiHamburgerMenu
                className={classes.burgerIcon}
                onClick={handleBurgerClick}
              />
            </Link>
            <h1 className={classes.headingText}>Mapper</h1>
          </div>

          <br />

          <div className={classes.defaultPage}>
            <div class="row">
              <div class="col">
                <Link to="/profile">
                  <button className={classes.defaultCurrencyPageButton}>
                    Profile
                  </button>
                </Link>

                <Link to="/active-currencies">
                  <button className={classes.defaultCurrencyPageButton}>
                    Active Currencies
                  </button>
                </Link>

                <Link to="/global-settings">
                  <button className={classes.defaultCurrencyPageButton}>
                    Global Settings
                  </button>
                </Link>
                <Link to="/credit-notes">
                  <button className={classes.defaultCurrencyPageButton}>
                    Credit Notes
                  </button>
                </Link>
                <Link to="/transactions">
                  <button className={classes.defaultCurrencyPageButton}>
                    Transactions
                  </button>
                </Link>
                <Link to="/processed-transactions">
                  <button className={classes.defaultCurrencyPageButton}>
                    Processed Transactions
                  </button>
                </Link>
              </div>
              <div class="col">
                <Link to="/listCurrency">
                  <button className={classes.defaultCurrencyPageButton}>
                    Currencies List
                  </button>
                </Link>
                <Link to="/cost-center-1">
                  <button className={classes.defaultCurrencyPageButton}>
                    Cost Center 1
                  </button>
                </Link>
                {defaultMapper !== IASLiveMapper && (
                  <>
                    <Link to="/cost-center-2">
                      <button className={classes.defaultCurrencyPageButton}>
                        Cost Center 2
                      </button>
                    </Link>
                    <Link to="/cost-center-3">
                      <button className={classes.defaultCurrencyPageButton}>
                        Cost Center 3
                      </button>
                    </Link>
                    <Link to="/vendors-list">
                      <button className={classes.defaultCurrencyPageButton}>
                        Vendors List
                      </button>
                    </Link>
                  </>
                )}
                <Link to="/listClient">
                  <button className={classes.defaultCurrencyPageButton}>
                    Clients List
                  </button>
                </Link>
                <Link to="/accruals-list">
                  <button className={classes.defaultCurrencyPageButton}>
                    Accruals List
                  </button>
                </Link>
                <Link to="/service-page">
                  <button className={classes.defaultCurrencyPageButton}>
                    Service Category List
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={classes.menuBar}>
            <IoClose
              className={classes.closeIcon}
              onClick={handleBurgerClick}
            />
            <ul className={classes.menuList}>
              <li>
                <Link to="/profile">
                  <button className={classes.sidebarButton}>Profile</button>
                </Link>
              </li>

              <li>
                <Link to="/active-currencies">
                  <button className={classes.sidebarButton}>
                    Active Currencies
                  </button>
                </Link>
              </li>

              <li>
                <Link to="/listCurrency">
                  <button className={classes.sidebarButton}>
                    Show Currency List
                  </button>
                </Link>
              </li>
              <li>
                <Link to="/listClient">
                  <button className={classes.sidebarButton}>
                    Show Clients List
                  </button>
                </Link>
              </li>

              <li>
                <Link to="/cost-center-1">
                  <button className={classes.sidebarButton}>
                    Show Cost Center 1
                  </button>
                </Link>
              </li>
              {defaultMapper !== IASLiveMapper && (
                <>
                  <li>
                    <Link to="/cost-center-2">
                      <button className={classes.sidebarButton}>
                        Show Cost Center 2
                      </button>
                    </Link>
                  </li>
                  <li>
                    <Link to="/cost-center-3">
                      <button className={classes.sidebarButton}>
                        Show Cost Center 3
                      </button>
                    </Link>
                  </li>
                  <li>
                    <Link to="/vendor-list">
                      <button className={classes.sidebarButton}>
                        Show Vendors List
                      </button>
                    </Link>
                  </li>
                </>
              )}
              <li>
                <Link to="/accruals-list">
                  <button className={classes.sidebarButton}>
                    Show Accruals List
                  </button>
                </Link>
              </li>
              <li>
                <Link to="/service-page">
                  <button className={classes.sidebarButton}>
                    Show Service Category List
                  </button>
                </Link>
              </li>
              <li>
                <Link to="/transactions">
                  <button className={classes.sidebarButton}>
                    Show Transactions
                  </button>
                </Link>
              </li>
              <li>
                <Link to="/processed-transactions">
                  <button className={classes.defaultCurrencyPageButton}>
                    Processed Transactions
                  </button>
                </Link>
              </li>
              <li>
                <Link to="/global-settings">
                  <button className={classes.defaultCurrencyPageButton}>
                    Global Settings
                  </button>
                </Link>
              </li>
            </ul>
          </div>
        </>
      )}
    </Fragment>
  );
}
